import { deleteItem, update } from "../components/indexDB/indexDBStora";

const VALID_ROUTES = ["employee", "investory", "category", "product", "schedule", "invoice", "transaction"];

const API_ACTIONS = {
  new: "create",
  update: "update",
  delete: "delete",
};

const STORE_MAP = {
  employee: "employees",
  investory: "investories",
  category: "categories",
  product: "products",
  schedule: "schedule",
  invoice: "invoices",
  transaction: "transactions"
};

const KEY_MAP = {
  employee: "id",
  investory: "id",
  category: "id",
  product: "meta.barcode",
  schedule: "id",
  invoice: "id",
  transaction: "id"
};

function getValue(obj, path) {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

export async function Asynchronous(data, route) {
  const api = process.env.REACT_APP_API_URL;
  if (!data || !data.length) return;
  
  if (!VALID_ROUTES.includes(route)) {
    console.log("the route is undefined");
    return;
  }
  
  const storeName = STORE_MAP[route];
  
  const operations = {
    new: [],
    update: [],
    delete: [],
  };
  
  data.forEach((item) => {
    if (item?.async?.status === "f") {
      const reason = item?.async?.reason;
      if (operations[reason]) {
        operations[reason].push(item);
      }
    }
  });

  try {

    for (const type of Object.keys(operations)) {
      const items = operations[type];

      if (!items.length) continue;

      const action = API_ACTIONS[type];

      const res = await fetch(`${api}/${route}/${action}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ data: items }),
      });

      const result = await res.json();

      if (result.status) {
        await Promise.all(
        items.map(async (item) => {
          const keyPath = KEY_MAP[route];
          const key = getValue(item, keyPath);

          if (type === "delete") {
            await deleteItem(storeName, key);
            return;
          }
          item.async.status = "t";
          return update(storeName, item);
        })
      );
      } else {
        console.log(`Error in ${type}:`, result.message);
      }
    }
  } catch (err) {
    console.error(err);
  }
}
